"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

// Copyright © 2019 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var Ns = /*#__PURE__*/function () {
  function Ns(service) {
    (0, _classCallCheck2["default"])(this, Ns);
    this._api = service;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(Ns, [{
    key: "generateDevAddress",
    value: function () {
      var _generateDevAddress = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.GenerateDevAddr();

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function generateDevAddress() {
        return _generateDevAddress.apply(this, arguments);
      }

      return generateDevAddress;
    }()
  }, {
    key: "getDefaultMacSettings",
    value: function () {
      var _getDefaultMacSettings = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(freqPlan, phyVersion) {
        var result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._api.GetDefaultMACSettings({
                  routeParams: {
                    frequency_plan_id: freqPlan,
                    lorawan_phy_version: phyVersion
                  }
                });

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getDefaultMacSettings(_x, _x2) {
        return _getDefaultMacSettings.apply(this, arguments);
      }

      return getDefaultMacSettings;
    }()
  }]);
  return Ns;
}();

var _default = Ns;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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